module.exports = __webpack_public_path__ + "static/racism-5ecb4889232741945c3027edc359c4c5.png";